// extracted by mini-css-extract-plugin
export default {"container":"TagsManagement_container__BIMdy"};